"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableContent = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrapTableNext = _interopRequireDefault(require("react-bootstrap-table-next"));
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class TableContent extends _react.PureComponent {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "input", void 0);
  }
  componentDidMount() {
    const {
      setValue,
      name
    } = this.props;
    if (setValue) {
      setValue(name, this.input.props.data || []);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      setValue,
      name,
      data
    } = this.props;
    if (prevProps.data !== data && setValue) {
      setValue(name, this.input.props.data || []);
    }
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_reactBootstrapTableNext.default, (0, _extends2.default)({
      ref: n => this.input = n
    }, this.props));
  }
}
exports.TableContent = TableContent;